export default "__VITE_ASSET__0ed59e23__"